import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from '@App/app/auth/auth.service';
import { Model } from '@App/app/entities/models/model.model';
import { ApiService } from '@App/app/shared/api.service';
import { Observable } from 'rxjs';
import { StartUploadDTO } from '../../models/start-upload-dto.model';
import { StartUploadResponse } from '../../models/start-upload-response.model';
import { UploadPendingStatusResponse } from '../../models/upload-pending-status-response.model';

@Injectable({ providedIn: 'root' })
export class UploaderHttpService extends ApiService {
  constructor(authService: AuthService, http: HttpClient) {
    super(authService, http);
  }

  getModels(): Observable<{ data: Model[] }> {
    return this.http.get<{ data: Model[] }>(`${this.api}/models`);
  }

  startUpload(dto: StartUploadDTO) {
    return this.http.post<StartUploadResponse>(`${this.api}/buildProcess/upload/start`, dto);
  }

  pauseUpload(buildProcessId: number) {
    return this.http.post<boolean>(`${this.api}/buildProcess/${buildProcessId}/upload/pause`, null);
  }

  cancelUpload(buildProcessId: number) {
    return this.http.post<boolean>(
      `${this.api}/buildProcess/${buildProcessId}/upload/cancel`,
      null,
    );
  }

  finishUpload(buildProcessId: number) {
    return this.http.post<boolean>(
      `${this.api}/buildProcess/${buildProcessId}/upload/finish`,
      null,
    );
  }

  getPendingUploadStatus(id: number) {
    return this.http.get<UploadPendingStatusResponse>(
      `${this.api}/buildProcess/getPendingUploadForTower/${id}`,
    );
  }
}
